import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['stepsList', 'sentinel']

  connect() {
    this.offset = 10;
    this.loading = false;
    this.hasMore = true;

    this.observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        this.loadMore();
      }
    });

    if (this.hasSentinelTarget) {
      this.observer.observe(this.sentinelTarget)
    }
  }

  disconnect() {
    if (this.observer && this.hasSentinelTarget) {
      this.observer.unobserve(this.sentinelTarget)
    }
  }

  loadMore() {

    this.loading = true;

    let accountId = this.element.dataset.accountId;
    let processTemplateId = this.element.dataset.processTemplateId;

    const url = `/${accountId}/process_templates/${processTemplateId}/load_more_step_templates?offset=${this.offset}`;

    fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => response.json())
      .then(data => {
        this.sentinelTarget.insertAdjacentHTML("beforebegin", data.html);
        if (!data.more_step_templates) {
          this.hasMore = false;
          this.observer.unobserve(this.sentinelTarget);
          document.querySelector('.process-end').innerHTML = data.process_end_html;
        }
        this.offset += 10;
      }).catch(error => console.error("Error loading more steps: ", error))
      .finally(() => {
        this.loading = false
      })
  }
}